<template>
  <div
    class="email-cell"
  >
    <div
      v-for="(email, index) in emailList"
      :key="index"
    >
      {{ `${email}${emailDelimiter}` }}
    </div>
  </div>
</template>

<script>
import { emailSeparator } from '@/api/postman/consts'
import { splitEmails } from '@/api/postman/util'
import { computed } from 'vue-demi'

export default {
  props: {
    emails: {
      type: String,
      default: '',
    },
    emailDelimiter: {
      type: String,
      default: emailSeparator,
    },
  },
  setup (props) {
    return {
      emailList: computed(() => {
        return splitEmails(props.emails, props.emailDelimiter)
      }),
    }
  },
}
</script>
